import { z } from "zod";
import { Tables } from "@/gen/tableNames/tables";
import { dynamicFormConfig } from "../edit-form-conf";
import { TFunction } from "i18next";

const commitmentRecord: (t: TFunction) => {
  label: string;
  validator: z.ZodTypeAny;
} = (t: TFunction) => {
  return {
    label: t(`${Tables.N1_STATIC_DATA}.columns.commitment`, {
      ns: "tables",
    }),
    validator: dynamicFormConfig.commitment,
  };
};

const capitalCallableRecord: (t: TFunction) => {
  label: string;
  validator: z.ZodTypeAny;
} = (t: TFunction) => {
  return {
    label: t(`${Tables.N1_STATIC_DATA}.columns.capital_callable`, {
      ns: "tables",
    }),
    validator: dynamicFormConfig.capital_callable,
  };
};

const maturityDateRecord: (t: TFunction) => {
  label: string;
  validator: z.ZodTypeAny;
} = (t: TFunction) => {
  return {
    label: t(`${Tables.N1_STATIC_DATA}.columns.maturity_date`, {
      ns: "tables",
    }),
    validator: dynamicFormConfig.maturity_date,
  };
};

const couponRateRecord: (t: TFunction) => {
  label: string;
  validator: z.ZodTypeAny;
} = (t: TFunction) => {
  return {
    label: t(`${Tables.N1_STATIC_DATA}.columns.coupon_rate`, {
      ns: "tables",
    }),
    validator: dynamicFormConfig.coupon_rate,
  };
};

const stockOptionStrikeRecord: (t: TFunction) => {
  label: string;
  validator: z.ZodTypeAny;
} = (t: TFunction) => {
  return {
    label: t(`${Tables.N1_STATIC_DATA}.columns.stock_option_strike`, {
      ns: "tables",
    }),
    validator: dynamicFormConfig.stock_option_strike,
  };
};

/**
 * List of fields that shall be displayed in the EDIT/NEW card and that depend on the assetclass2
 * These fields will be displayed in the "Detailed information"/"Informations détaillées" section
 */
export const detailedInformationByAssetClass2: (
  t: any,
) => Record<
  string,
  Record<string, { label: string; validator: z.ZodTypeAny }>
> = (t: any) => {
  return {
    energy_and_climate: {
      commitment: commitmentRecord(t),
      capital_callable: capitalCallableRecord(t),
    },
    media_and_humanity: {
      commitment: commitmentRecord(t),
      capital_callable: capitalCallableRecord(t),
    },
    private_debt: {
      commitment: commitmentRecord(t),
      capital_callable: capitalCallableRecord(t),
    },
    other_private_equity: {
      commitment: commitmentRecord(t),
      capital_callable: capitalCallableRecord(t),
    },
    infrastructure: {
      commitment: commitmentRecord(t),
      capital_callable: capitalCallableRecord(t),
    },
    real_estate: {
      commitment: commitmentRecord(t),
      capital_callable: capitalCallableRecord(t),
    },
    group: {
      commitment: commitmentRecord(t),
      capital_callable: capitalCallableRecord(t),
    },
    pharma: {
      commitment: commitmentRecord(t),
      capital_callable: capitalCallableRecord(t),
    },
    fixed_income: {
      maturity_date: maturityDateRecord(t),
      coupon_rate: couponRateRecord(t),
    },
    cash: {
      maturity_date: maturityDateRecord(t),
      coupon_rate: couponRateRecord(t),
    },
    stock_option: {
      stock_option_strike: stockOptionStrikeRecord(t),
    },
  };
};
